module.exports = __webpack_public_path__ + "static/media/mothership-target.60cb2a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hubspot/mothership-target.png
// module id = 968
// module chunks = 0